module.exports = __webpack_public_path__ + "media/images/photo/line-a609038f831cfddc87aea4b5554a1127.png";